// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Cs-z","heading":"Ds-z","brandPromo":"Es-z"};